export default "__VITE_ASSET__va7X6Qvj__"